const FILE_EXTENSIONS_REGEXP = /^$|^.*\.(txt|csv|xlsx|xls|ods)$/i;
const FILE_NAME_REGEXP = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
const PHONE_NUMBER_REGEXP = /^(1[ \-\+]{0,3}|\+1[ -\+]{0,3}|\+1|\+)?((\(\+?1-[2-9][0-9]{1,2}\))|(\(\+?[2-8][0-9][0-9]\))|(\(\+?[1-9][0-9]\))|(\(\+?[17]\))|(\([2-9][2-9]\))|([ \-\.]{0,3}[0-9]{2,4}))?([ \-\.][0-9])?([ \-\.]{0,3}[0-9]{2,4}){2,3}$/; // eslint-disable-line

export {
  FILE_NAME_REGEXP,
  PHONE_NUMBER_REGEXP,
  FILE_EXTENSIONS_REGEXP,
};
